import React, { lazy } from 'react';
import { filterList, filterWithDateRange } from 'globalutils/fmUtils';
import moment from 'moment';
import { BACKEND_DATE_FORMAT } from 'globalconfig/constants/static';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));

const filterLogsListForm = (
  values,
  list,
  filterSuccess,
  setValues,
  fields,
  isServer,
  filterLogsList,
  i18n,
  setPagination,
  setIsFilterClicked
) => {
  const handleSubmit = () => {
    if (isServer) {
      const data = {
        startDate: values.dateFrom ? moment(values.dateFrom).format(BACKEND_DATE_FORMAT) : null,
        endDate: values.dateTo ? moment(values.dateTo).format(BACKEND_DATE_FORMAT) : null,
        driverId: values.driver_name?.value,
      };
      filterLogsList(data);
    } else {
      const filters = values;
      Object.keys(filters).forEach((key) => {
        if (filters[key] === null || filters[key] === '') {
          delete filters[key];
        }
      });
      let result = list.list;

      if (values.dateFrom || values.dateTo) {
        result = filterWithDateRange(result, values.dateFrom, values.dateTo);
      }

      if (values.driver_name) {
        result = filterList(result, 'driver_name', values.driver_name);
      }

      filterSuccess(result);
    }
    setPagination(true);
    setIsFilterClicked(true);
  };

  const handleCancel = () => {
    if (isServer) {
      filterLogsList({
        startDate: null,
        endDate: null,
        driverId: null,
      });
    } else {
      filterSuccess(list.list);
    }
    setValues({ driver_name: '', dateFrom: '', dateTo: '' });
    setPagination(true);
    setIsFilterClicked(false);
  };

  return (
    <Form
      type="client"
      direction="row"
      values={{ ...values }}
      className="filterForm"
      handleOnSubmit={handleSubmit}
      handleOnCancel={handleCancel}
      setValues={setValues}
      fields={[...fields, { type: 'submit', value: i18n.t('common.view') }, { type: 'reset', value: i18n.t('common.clear') }]}
    />
  );
};
export default filterLogsListForm;
